var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DoubleDroite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7.984375 2.984375 A 1.50015 1.50015 0 0 0 6.9394531 5.5605469 L 25.378906 24 L 6.9394531 42.439453 A 1.50015 1.50015 0 1 0 9.0605469 44.560547 L 28.560547 25.060547 A 1.50015 1.50015 0 0 0 28.560547 22.939453 L 9.0605469 3.4394531 A 1.50015 1.50015 0 0 0 7.984375 2.984375 z M 19.984375 2.984375 A 1.50015 1.50015 0 0 0 18.939453 5.5605469 L 37.378906 24 L 18.939453 42.439453 A 1.50015 1.50015 0 1 0 21.060547 44.560547 L 40.560547 25.060547 A 1.50015 1.50015 0 0 0 40.560547 22.939453 L 21.060547 3.4394531 A 1.50015 1.50015 0 0 0 19.984375 2.984375 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DoubleDroite);
export default __webpack_public_path__ + "static/media/icons8-double-droite.512675af6cfe02e0110982195968b435.svg";
export { ForwardRef as ReactComponent };